import {
  WidgetTitle as LibWidgetTitle,
  mapWidgetTitleSettings
} from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export function WidgetTitle() {
  const settings = useSettings();
  const widgetTitleSettings = mapWidgetTitleSettings(settings);

  return (
    <LibWidgetTitle
      className={createReadableClass({ component: 'widget-title' })}
      bottomOffset={32}
      {...widgetTitleSettings}
    />
  );
}
